import { GridCellProps } from "@progress/kendo-react-grid";

export const BooleanCell = (props: GridCellProps) => {
  return (
    <td
      aria-colindex={props.columnIndex}
      role="gridcell"
      onContextMenu={(ev) => props.onContextMenu!(ev, props.dataItem)}
    >
      {props.dataItem[props.field!] ? "Oui" : "Non"}
    </td>
  );
};